import { AxiosResponse } from 'axios';
import { ScreenRegistrationRequest } from '@/main/models/request/screenRequest';
import { IScreenApi } from './base/screenApi';
import { api } from './base';
import { Result } from '../models/common/resultResponse';
import { ScreenRegistrationDataResponse } from '../models/response/screenResponse';

const baseRoute: string = 'Screen';

export class ScreenApi extends IScreenApi {
  private activeAbortController: AbortController | null = null;

  async getByGroupWithPermissions(
    request: ScreenRegistrationRequest
  ): Promise<AxiosResponse<Result<ScreenRegistrationDataResponse[]>>> {
    if (this.activeAbortController) {
      this.activeAbortController.abort();
    }
    this.activeAbortController = new AbortController();
    const response = await api.get(`${baseRoute}/getByGroupWithPermissions`, {
      params: request,
      signal: this.activeAbortController.signal
    });
    this.activeAbortController = null;
    return response;
  }
}

